import Swiper, { Navigation } from 'swiper';

export default function initCarouselBlock() : void {
    const $carouselContainer = document.querySelectorAll<HTMLElement>('.carousel-wrapper');

    $carouselContainer.forEach($container => {
        new CarouselBlock($container);
    });
}

class CarouselBlock {
    $el: HTMLElement | null | undefined;
    $navigationSlider: HTMLElement | null | undefined;
    $imageSlider: NodeListOf<HTMLElement> | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$navigationSlider = this.$el?.querySelector('.carousel-navigation');
        this.$imageSlider = this.$el?.querySelectorAll('.carousel-slider-elements');
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
        this.createImageSwiper();
    }

    /**
     * Événement lancé à chaque resize de la fenêtre
     * Détermine s'il faut créer ou détruire le swiper
     */
    onWindowResize(): void {

        if (this.$navigationSlider) {
            const $buttons = this.$navigationSlider.querySelectorAll<HTMLElement>('.carousel-navigation-button');
            let $buttonsLenght = 0;
            const $buttonsContainerWidth =  this.$navigationSlider.offsetWidth;
            $buttons.forEach((button) => {
                $buttonsLenght += button.offsetWidth;
            })
            
            
            if (!this.swiper && $buttonsContainerWidth && $buttonsLenght > $buttonsContainerWidth) {
                // Créé le swiper s'il n'est pas déjà créé et que la taille liste des boutons n'est pas supérieure a celle de son container
                this.createNavigationSwiper();
            }
            else {
                // Détruit le swiper s'il est déjà créé et que la liste des boutons n'est pas supérieure a celle de son container
                this.destroyNavigationSwiper();
            }
        }
    }

    /**
     * Créé le swiper nav
     */
    createNavigationSwiper(): void {
        if (this.$navigationSlider) {

            this.$navigationSlider.classList.add('carousel-navigation--pagination');
            this.$navigationSlider.querySelector('.slider-next')?.classList.add('slider-next--active');
            this.$navigationSlider.querySelector('.slider-prev')?.classList.add('slider-prev--active');

            new Swiper(this.$navigationSlider, {
                modules: [Navigation],
                slidesPerView: 'auto',
                loop: false,
                allowTouchMove: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },
            });
        }
    }

    /**
     * Détruit le swiper nav
     */
    destroyNavigationSwiper(): void {
        if (this.$navigationSlider) {
            this.$navigationSlider.classList.remove('carousel-navigation--pagination');
            this.$navigationSlider.querySelector('.slider-next')?.classList.remove('slider-next--active');
            this.$navigationSlider.querySelector('.slider-prev')?.classList.remove('slider-prev--active');
        }
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }

    /**
     * Créé le swiper nav
     */
    createImageSwiper(): void {
        if (this.$imageSlider) {
            this.$imageSlider.forEach(($slider: HTMLElement) => {
                new Swiper($slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    loop: false,
                    allowTouchMove: true,
                    grabCursor: true,
                });

                // Fix du carousel sur les pages avec navigation latérale
                const $pageWithAsideNav = $slider.closest<HTMLElement>('.page-with-aside-nav');
                if ($pageWithAsideNav) {
                    this.fixCarouselInPageWithAsideNav($slider, $pageWithAsideNav);

                    window.addEventListener('resize', () => {
                        this.fixCarouselInPageWithAsideNav($slider, $pageWithAsideNav);
                    });
                }

                // Fix du carousel sur les pages avec un single-share-wrapper
                const $singleSharePage = $slider.closest<HTMLElement>('.single-share-page');
                if ($singleSharePage) {
                    this.fixCarouselInSingleSharePage($slider, $singleSharePage);

                    window.addEventListener('resize', () => {
                        this.fixCarouselInSingleSharePage($slider, $singleSharePage);
                    });
                }
            });
        }
    }

    /**
     * Fix du carousel sur les pages avec navigation latérale
     * 
     * @param {HTMLElement} $slider
     * @param {HTMLElement} $pageWithAsideNav 
     */
    fixCarouselInPageWithAsideNav($slider: HTMLElement, $pageWithAsideNav: HTMLElement): void {
        const $block = $slider.closest('.wp-block') as HTMLElement;

        const pageWidth = document.body.clientWidth;
        const LgBreakpointWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'));
        const asideWidth = parseInt(getComputedStyle($pageWithAsideNav).getPropertyValue('--aside-width'));
        const asideGapWidth = parseInt(getComputedStyle($pageWithAsideNav).getPropertyValue('--aside-gap'));

        if (window.innerWidth >= LgBreakpointWidth) {
            $block.style.width = '0px';
            $slider.style.width = '0px';

            // Taille des marges externes au contenu (ce qui dépasse du container du site)
            const marginOutOfContainerWidth = (pageWidth - $pageWithAsideNav.clientWidth) / 2;
            const contentWidth = $pageWithAsideNav.clientWidth - asideWidth - asideGapWidth;

            $block.style.width = contentWidth + 'px';
            $slider.style.width = (contentWidth + marginOutOfContainerWidth) + 'px';
        } else {
            $block.style.width = '';
            $slider.style.width = '';
        }
    }

    /**
     * Fix du carousel sur les pages avec un
     * 
     * @param {HTMLElement} $slider
     * @param {HTMLElement} $singleSharePage 
     */
    fixCarouselInSingleSharePage($slider: HTMLElement, $singleSharePage: HTMLElement): void {
        const $block = $slider.closest('.wp-block') as HTMLElement;

        const pageWidth = document.body.clientWidth;
        const LgBreakpointWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'));
        const asideWidth = parseInt(getComputedStyle($singleSharePage).getPropertyValue('--single-share-wrapper-width'));

        if (window.innerWidth >= LgBreakpointWidth) {
            $block.style.width = '0px';
            $slider.style.width = '0px';

            // Taille des marges externes au contenu (ce qui dépasse du container du site)
            const marginOutOfContainerWidth = (pageWidth - $singleSharePage.clientWidth) / 2;
            const contentWidth = $singleSharePage.clientWidth - asideWidth;

            $block.style.width = contentWidth + 'px';
            $slider.style.width = (contentWidth + marginOutOfContainerWidth) + 'px';
        } else {
            $block.style.width = '';
            $slider.style.width = '';
        }
    }
}
